import { datadogRum } from '@datadog/browser-rum'
import Config from '../Data/Config.json'

class DatadogService {
    private _initialized = false

    init(isDev: boolean) {
        if (this._initialized) return
        this._initialized = true

        const { applicationId, clientToken, site } = Config.datadog

        datadogRum.init({
            applicationId,
            clientToken,
            site,
            env: isDev ? 'dev' : 'prod',
            sessionSampleRate: 100,
            sessionReplaySampleRate: 0,
            trackResources: true,
            trackLongTasks: true,
            trackUserInteractions: true,
        })
    }

    trackAction(name: string, context?: Record<string, unknown>) {
        if (!this._initialized) return
        datadogRum.addAction(name, context)
    }

    trackError(error: unknown, context?: Record<string, unknown>) {
        if (!this._initialized) return
        datadogRum.addError(error, context)
    }
}

export default new DatadogService()
